const ADD_SHOPS = "ADD_SHOPS";
const ADD_SHOPS_SUCCESS = "ADD_SHOPS_SUCCESS";
const ADD_SHOPS_FAILURE = "ADD_SHOPS_FAILURE";
const CLEAR_ADD_SHOPS = "CLEAR_ADD_SHOPS";

const AddshopsSymbols = {
  ADD_SHOPS_SUCCESS,
  ADD_SHOPS_FAILURE,
  ADD_SHOPS,
  CLEAR_ADD_SHOPS,
};
export default AddshopsSymbols;
